import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'breath';
const args = {};

export class Breath extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
